export default __webpack_public_path__ + "static/media/nosotros-3.60cb4f6a.jpg";